export const languages = [
    { value: 'en', label: 'English' },
    { value: 'fr', label: 'French' },
    { value: 'hi', label: 'Hindi' },
    { value: 'ru', label: 'Russian' },
    { value: 'es', label: 'Spanish' },
    { value: 'zh', label: 'Chinese' },
    { value: 'nl', label: 'Dutch' },
    { value: 'ar', label: 'Arabic' },
    { value: 'bn', label: 'Bengali' },
    { value: 'pt', label: 'Portuguese' },
    { value: 'ur', label: 'Urdu' },
    { value: 'id', label: 'Indonesian' },
    { value: 'de', label: 'German' },
    { value: 'cmn', label: 'Mandarin' },
    { value: 'ja', label: 'Japanese' },
    { value: 'mr', label: 'Marathi' },
    { value: 'te', label: 'Telugu' },
    { value: 'ta', label: 'Tamil' },
    { value: 'tr', label: 'Turkish' },
    { value: 'ko', label: 'Korean' },
    { value: 'vi', label: 'Vietnamese' },
    { value: 'it', label: 'Italian' },
    { value: 'ha', label: 'Hausa' },
    { value: 'th', label: 'Thai' },
    { value: 'gu', label: 'Gujarati' },
    { value: 'kn', label: 'Kannada' },
    { value: 'bho', label: 'Bhojpuri' },
    { value: 'fil', label: 'Filipino' },
    { value: 'my', label: 'Burmese' },
    { value: 'pl', label: 'Polish' },
    { value: 'yo', label: 'Yoruba' },
    { value: 'or', label: 'Odia' },
    { value: 'ml', label: 'Malayalam' },
    { value: 'mai', label: 'Maithili' },
    { value: 'uk', label: 'Ukrainian' },
    { value: 'pa', label: 'Eastern Punjabi' },
    { value: 'su', label: 'Sundanese' },
    { value: 'sw', label: 'Swahili' },
    { value: 'pnb', label: 'Western Punjabi' },
    { value: 'wuu', label: 'Wu Chinese' },
    { value: 'yue', label: 'Yue Chinese' },
    { value: 'jv', label: 'Javanese' },
    { value: 'arz', label: 'Egyptian Spoken Arabic' },
    { value: 'fa', label: 'Iranian Persian' },
    { value: 'nan', label: 'Southern Min Chinese' },
    { value: 'hak', label: 'Hakka Chinese' },
    { value: 'cjy', label: 'Jinyu Chinese' },
    { value: 'ary', label: 'Moroccan Spoken Arabic' },
    { value: 'arq', label: 'Algerian Spoken Arabic' },
    { value: 'apd', label: 'Sudanese Spoken Arabic' },
    { value: 'pcm', label: 'Nigerian Pidgin' },
    { value: 'hsn', label: 'Xiang Chinese' }
]

// Returns the locale to bake into the Mukham (OTP liveness) SDK token.
//
// Mukham resolves the language itself and carries the same 52 codes as the list
// above: it ships translations for 36 of them and maps the remaining dialects onto
// their closest relative (Wu/Yue/Hakka/Xiang/Mandarin -> zh, Bhojpuri/Maithili ->
// hi, the spoken Arabics -> ar, Javanese/Sundanese -> id, Western Punjabi -> ur),
// falling back to English only when it has nothing closer. So the journey language
// goes through untouched — an allowlist here can only take away copy Mukham has.
//
// Blank values default to English here rather than being passed on: the backend
// only defaults the locale when the key is absent, and rejects an empty string
// outright ('"locale" is not allowed to be empty'). That 400 would leave the page
// on its loader with no token and no error to show.
export const getMukhamLocale = (language) => language?.trim() || 'en';
